export const FACTORY_STATE_SYMBOL = Symbol.for("@visactor/vrender-core/factory-state");

function createFactoryState() {
    return {
        pluginClasses: {}
    };
}

export function getFactoryState() {
    const scope = globalThis;
    return scope[FACTORY_STATE_SYMBOL] || (scope[FACTORY_STATE_SYMBOL] = createFactoryState()), 
    scope[FACTORY_STATE_SYMBOL];
}
//# sourceMappingURL=factory-state.js.map